<script lang="ts">
  import Icon from './Icon.svelte'

  export let icon: string | undefined = undefined
  export let open = false
  export let title: string
  let content: HTMLDivElement | undefined
  let panel: HTMLDetailsElement | undefined
  let summary: HTMLElement | undefined
  $: handleOpen(open)

  function handleOpen(open: boolean) {
    if (content && summary && panel) {
      panel.style.overflow = 'hidden'
      panel.style.height = `${panel.offsetHeight}px`
      const startHeight = `${panel.offsetHeight}px`

      if (open) {
        const endHeight = `${64 + content.offsetHeight}px`

        const animation = panel.animate(
          {
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
          },
          {
            duration: 250,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          },
        )

        animation.onfinish = animationFinish
      } else {
        const endHeight = '48px'

        const animation = panel.animate(
          {
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
          },
          {
            duration: 250,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          },
        )

        animation.onfinish = animationFinish
      }
    }
  }

  function animationFinish() {
    if (panel) {
      panel.style.height = panel.style.overflow = ''
    }
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      open = !open
    }
  }
</script>

<details class="panel" {open} bind:this={panel}>
  <summary
    role="tree"
    tabindex="0"
    class="title"
    on:keydown|preventDefault={handleKeydown}
    on:click|preventDefault={() => (open = !open)}
    bind:this={summary}
  >
    {#if icon}
      <Icon {icon} />
    {/if}
    {title}
    <div class="arrow">
      <Icon icon="ph-caret-down" size={1.1} />
    </div>
  </summary>
  <div class="content" bind:this={content}>
    <slot />
  </div>
</details>

<style lang="scss">
  summary::-webkit-details-marker {
    display: none;
  }

  .panel {
    border-radius: 4px;
    box-shadow:
      0 3px 1px -2px rgba(0, 0, 0, var(--box-shadow-opacity-1, 0.2)),
      0 2px 2px 0 rgba(0, 0, 0, var(--box-shadow-opacity-2, 0.14)),
      0 1px 5px 0 rgba(0, 0, 0, var(--box-shadow-opacity-3, 0.12));

    .title {
      background-color: rgb(var(--expansion-panel-background));
    }
  }

  .panel[open] {
    & > .title {
      height: 64px;
      background-color: rgba(
        var(--expansion-panel-background, 0, 0, 0),
        var(--expansion-panel-background-opacity, 0.12)
      );

      .arrow {
        transform: rotate(180deg);
      }
    }
  }

  .title {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 4px 4px 0 0;
    padding: 16px 24px;
    min-height: 48px;
    transition:
      0.3s height cubic-bezier(0.4, 0, 0.2, 1),
      0.3s background-color cubic-bezier(0.4, 0, 0.2, 1);

    .arrow {
      margin-left: auto;
      transition: transform 0.25s;
    }
  }

  .content {
    padding: 8px 24px 16px;
  }
</style>
